module.exports = __webpack_public_path__ + "static/media/HandMeDown.c0ee1130.png";